import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { authRedirectSave } from '../../../actions/AuthActions';
import { propStr, propChildren } from '../../../helpers/custom-prop-types';
const LoginButton = (props) => {
    const { className, text } = props;
    const location = useLocation();
    const dispatch = useDispatch();
    const onClickLogin = useCallback(() => {
        const { pathname, search } = location;
        dispatch(authRedirectSave(`${pathname}${search}`));
    }, [dispatch, location]);
    return (_jsx(Link, Object.assign({ className: className, onClick: onClickLogin, to: '/login' }, { children: text || 'ログイン' })));
};
LoginButton.propTypes = {
    className: propStr(),
    text: propChildren(),
};
LoginButton.defaultProps = {
    className: '',
    text: '',
};
export default LoginButton;
